<div id="sub-nav-options">
  <div class="option centered-vert pl-7px" [ngClass]="{ active: isActive(option) }" *ngFor="let option of options" (click)="view(option)">
    <span class="mr-4px" *ngIf="option.icon" [ngClass]="'gh-font-icon-' + option.icon"></span>
    <p class="fs-13px mb-0px fw-500 ink-60-v3 hov-cursor-p ellipsis">{{ option.label }}</p>
  </div>
</div>
